import React from 'react';
import { tIssue, eIssueStatus } from "../data/Issues";
import './EpicProgressCard.css'; // Add this to import the styles

interface EpicProgressCardProps {
  issues: tIssue[];
  sprint: number;
  mobileGame: boolean;
}

const EpicProgressCard: React.FC<EpicProgressCardProps> = ({ issues, sprint, mobileGame }) => {
  // Function to calculate the progress for each epic
  const calculateEpicProgress = (epic: string) => {
    const epicIssues = issues.filter(
      (issue) => issue.epic === epic && issue.available <= sprint
    );

    const totalIssues = epicIssues.length;
    const completedIssues = epicIssues.filter(
      (issue) => issue.status === eIssueStatus.Closed || issue.status === eIssueStatus.Done
    ).length;

    const progress = totalIssues === 0 ? 0 : (completedIssues / totalIssues) * 100;

    return progress;
  };

  // Get unique epics from the issues
  const uniqueEpics = Array.from(new Set(issues.filter(issue => issue.epic !== 'Misc').map((issue) => issue.epic)))
  .sort();  // Sort the epics alphabetically


  return (
    <div className="epic-progress-card">
      <div className="epic-columns">
        <div className="epic-column">
          {uniqueEpics.slice(0, 5).map((epic) => {
            const progress = calculateEpicProgress(epic);
            const isMobileGame = epic === "Mobile Game"; // Check if it's the "Mobile Game" epic
  
            return (
              <div key={epic} className="epic-item">
                <div className="progress-bar-container">
                  {
                    isMobileGame ? (
                      // If the Mobile Game epic is unlocked, show the progress bar
                      mobileGame ? (
                        <div
                          className={`progress-bar epic-${epic.toLowerCase().replace(/\s+/g, '-')}`}
                          style={{ width: `${progress}%` }}
                        >
                          <div className="progress-bar-text">
                            {epic} ({Math.round(progress)}%)
                          </div>
                        </div>
                      ) : (
                        // If not unlocked, show the padlock icon
                        <div className="progress-bar-lock">
                          <span role="img" aria-label="padlock">🔒</span> Locked
                        </div>
                      )
                    ) : (
                      // Show the progress bar for all other epics
                      <div
                        className={`progress-bar epic-${epic.toLowerCase().replace(/\s+/g, '-')}`}
                        style={{ width: `${progress}%` }}
                      >
                        <div className="progress-bar-text">
                          {epic} ({Math.round(progress)}%)
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
            );
          })}
        </div>
  
        <div className="epic-column">
          {uniqueEpics.slice(5).map((epic) => {
            const progress = calculateEpicProgress(epic);
            const isMobileGame = epic === "Mobile Game"; // Check if it's the "Mobile Game" epic
  
            return (
              <div key={epic} className="epic-item">
                <div className="progress-bar-container">
                  {
                    isMobileGame ? (
                      // If the Mobile Game epic is unlocked, show the progress bar
                      mobileGame ? (
                        <div
                          className={`progress-bar epic-${epic.toLowerCase().replace(/\s+/g, '-')}`}
                          style={{ width: `${progress}%` }}
                        >
                          <div className="progress-bar-text">
                            {epic} ({Math.round(progress)}%)
                          </div>
                        </div>
                      ) : (
                        // If not unlocked, show the padlock icon
                        <div className="progress-bar-lock">
                          <span role="img" aria-label="padlock">🔒</span> Locked
                        </div>
                      )
                    ) : (
                      // Show the progress bar for all other epics
                      <div
                        className={`progress-bar epic-${epic.toLowerCase().replace(/\s+/g, '-')}`}
                        style={{ width: `${progress}%` }}
                      >
                        <div className="progress-bar-text">
                          {epic} ({Math.round(progress)}%)
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
  
};

export default EpicProgressCard;
